// @ts-nocheck
import './advanced.scss';

import FilterBarSection from 'atoms/filterBar/filterBarSection';
import _ from 'lodash';
import { getGridFiltersByColumn } from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';

import { AgGridSearchFilter } from './components/agGridSearchFilter';

export default forwardRef((props, ref) => {
	const currentColumn = props?.colDef?.metaData;
	const tableId = currentColumn.AppTableID;
	let searchQueriesDefault = useSelector((state) =>
		getGridFiltersByColumn(state, tableId, currentColumn.AppColumnName)
	);
	searchQueriesDefault = _.filter(searchQueriesDefault, (val) => val.id);
	const [searchQueries, updateSearchQueries] = useState(searchQueriesDefault);

	const onClose = () => {
		props.api.hideColumnChooser(props.column);
	};

	useImperativeHandle(ref, () => {
		return {
			doesFilterPass(params) {},
			isFilterActive(params) {
				return Boolean(searchQueries.length);
			},
			getModel(params) {},
			setModel() {},
		};
	});

	useEffect(() => {
		if (!_.isEqual(searchQueriesDefault, searchQueries)) {
			updateSearchQueries(searchQueriesDefault);
		}
	}, [searchQueries, searchQueriesDefault]);
	let queries = searchQueries?.length ? [...searchQueries] : [{}];
	return (
		<FilterBarSection>
			<Stack gutter="small" isVertical>
				{_.map(queries, (query, index) => (
					<StackItem isStretch>
						<Stack isVertical gutter="small" position="center" align="center">
							<StackItem isStretch>
								<AgGridSearchFilter
									key={query?.id}
									currentColumnRef={{ ...props }}
									currentQuery={query}
									tableId={tableId}
									isInline
									onClose={onClose}
									onUpdateQueries={(params) => {
										updateSearchQueries(params);
										props?.api?.refreshServerSide({ route: [], purge: true });
									}}
								/>
							</StackItem>
						</Stack>
					</StackItem>
				))}
			</Stack>
		</FilterBarSection>
	);
});
